/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .resource-row[_ngcontent-%COMP%]   button.checkbox[_ngcontent-%COMP%]{color:#182365}[_nghost-%COMP%]   .resource-row[_ngcontent-%COMP%]   .resource_description[_ngcontent-%COMP%]{font-size:13px;font-weight:500;color:#212121;cursor:pointer}[_nghost-%COMP%]   .primary-input[_ngcontent-%COMP%]{margin-left:40px;font-size:smaller}"];
export { styles as styles };
